"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesHttpService = void 0;
const get_site_1 = require("../../types/sites/get-site");
const http_service_1 = require("../http.service");
class SitesHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/sites`);
    }
    getList(payload) {
        const params = {
            page: String(payload.page),
            per_page: String(payload.per_page),
        };
        return this.getEntityList('', {
            params,
        });
    }
    create(payload) {
        return this.postEntity('', {
            body: payload,
        });
    }
    getById(id) {
        return this.getEntity(id, {
            params: {
                include: 'offices',
            },
            schema: get_site_1.getSiteApiResponseSchema,
        });
    }
    update(id, payload) {
        return this.putEntity(id, {
            body: payload,
        });
    }
    createMedicalAssistantFee(siteId, payload) {
        return this.postEntity(`${siteId}/medical-assistant-fees`, {
            body: payload,
        });
    }
    getMedicalAssistantFees(siteId) {
        return this.getEntity(`${siteId}/medical-assistant-fees`);
    }
    createEmployerTotalCost(siteId, payload) {
        return this.postEntity(`${siteId}/employer-total-costs`, {
            body: payload,
        });
    }
    getEmployerTotalCosts(siteId) {
        return this.getEntity(`${siteId}/employer-total-costs`);
    }
}
exports.SitesHttpService = SitesHttpService;
